import type { MouseEventHandler, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { HpIcon } from '@hp/ui';
import { PipedriveIcon } from './ui/icons';
import { pdRecordUrl } from '../lib/pipedrive';

/**
 * Deep link into a Pipedrive record: logomark + label (defaults to #id) + ↗,
 * rendered as the design system's text detail action.
 */
export function PdLink({
  domain,
  entity,
  pdId,
  className,
  onClick,
  children,
}: {
  domain: string | null | undefined;
  entity: 'person' | 'organization' | 'deal';
  pdId: number | string;
  className?: string;
  onClick?: MouseEventHandler<HTMLAnchorElement>;
  children?: ReactNode;
}) {
  const { t } = useTranslation();
  return (
    <a
      href={pdRecordUrl(domain, entity, pdId)}
      target="_blank"
      rel="noreferrer"
      onClick={onClick}
      className={
        className
          ? `hp-detail-action hp-detail-action--text bo-pd-link ${className}`
          : 'hp-detail-action hp-detail-action--text bo-pd-link'
      }
      title={t('pipedrive.openRecord', { entity: t(`entity.${entity}`), id: pdId })}
    >
      <PipedriveIcon />
      <span>{children ?? <>#{pdId}</>}</span>
      <HpIcon name="arrowUpRight" />
    </a>
  );
}
